import { render, staticRenderFns } from "./billview.vue?vue&type=template&id=2050743a&lang=pug"
import script from "./billview.vue?vue&type=script&lang=js"
export * from "./billview.vue?vue&type=script&lang=js"
import style0 from "./billview.vue?vue&type=style&index=0&id=2050743a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports